const countryNames = {
  AU: "Australia",
  BR: "Brazil",
  CA: "Canada",
  FR: "France",
  HK: "Hong Kong",
  IN: "India",
  MY: "Malaysia",
  MX: "Mexico",
  PH: "Philippines",
  SG: "Singapore",
  ZA: "South Africa",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States of America",
  IE: "Ireland"
};
const euCountryNames = {
  AT: "Austria",
  BE: "Belgium",
  BG: "Bulgaria",
  HR: "Croatia",
  CY: "Cyprus",
  CZ: "Czechia",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finland",
  DE: "Germany",
  GR: "Greece",
  HU: "Hungary",
  IT: "Italy",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  MT: "Malta",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  SK: "Slovakia",
  SI: "Slovenia",
  ES: "Spain",
  SE: "Sweden"
};
const langPrefixArr = {
  AU: "en-au",
  BR: "pt-br",
  CA: "en-ca",
  FR: "fr-fr",
  HK: "en-hk",
  IN: "en-in",
  MY: "en-my",
  MX: "es-mx",
  PH: "en-ph",
  SG: "en-sg",
  ZA: "en-za",
  AE: "en-ae",
  GB: "en-gb",
  US: "en-us",
  "FR-CA": "fr-ca",
  EU: "en-de",
  GLOBAL: "x-default",
  IE: "en-ie"
};
const globalCountryNames = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CD: "Congo (the Democratic Republic)",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CU: "Cuba",
  CW: "Curaçao",
  CI: "Côte d'Ivoire",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands",
  FO: "Faroe Islands",
  FJ: "Fiji",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See",
  HN: "Honduras",
  IS: "Iceland",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IM: "Isle of Man",
  IL: "Israel",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (the Democratic People's Republic of)",
  KR: "Korea (the Republic of)",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MV: "Maldives",
  ML: "Mali",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  FM: "Micronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  QA: "Qatar",
  MK: "Republic of North Macedonia",
  RU: "Russian Federation",
  RW: "Rwanda",
  RE: "Réunion",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SX: "Sint Maarten",
  SB: "Solomon Islands",
  SO: "Somalia",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};
let geoData = {};

/**
 * Returns the value of the required query parameter, not found returns null.
 * @param {string} name  Name of the query parameter.
 */
const getURLParameter = (name) => {
  if (!name) {
    return null;
  }
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

/**
 * Returns the value of the cookie
 * @param  {string} name - the name of the cookie
 */
const getCookie = (name) => {
  var cookie = document.cookie,
    start_index = void 0,
    val_index = void 0,
    end_index = void 0;
  if (cookie.length) {
    // Prefix with "; " so every cookie is in the form "; name=value",
    // preventing "xivid=foo" from matching a search for "ivid".
    const cookieStr = "; " + cookie;
    start_index = cookieStr.indexOf("; " + name + "=");
    if (start_index !== -1) {
      val_index = start_index + name.length + 3;
      end_index = cookieStr.indexOf(";", val_index);
      if (end_index === -1) {
        end_index = cookieStr.length;
      }
      return decodeURIComponent(cookieStr.substring(val_index, end_index));
    }
  }
  return "";
};

/**
 * Returns true when the current page is already on the preferred site.
 * Handles both:
 *   - Relative paths  (e.g. "/uk/")   → compared against window.location.pathname
 *   - Absolute URLs   (e.g. "https://quickbooks.intuit.com/global/")
 *                                      → compared against origin + pathname so a
 *                                        pathname-only check cannot cause an infinite
 *                                        redirect when the saved value is an absolute URL.
 */
const isAlreadyOnPreferredSite = (savedPath) => {
  if (!savedPath) return false;
  try {
    const url = new URL(savedPath);
    return (
      window.location.origin === url.origin &&
      window.location.pathname.startsWith(url.pathname)
    );
  } catch {
    return window.location.pathname.startsWith(savedPath);
  }
};

/**
 * Derives the root path prefix for a given region code.
 * Used to save the "stay on current site" preference with the correct path
 * so the modal is only suppressed for pages belonging to that site.
 *
 * Examples:
 *   "US"    → "/"        (US site is served from the domain root)
 *   "uk"    → "/uk/"
 *   "fr-ca" → "/fr-ca/"
 *   "eu"    → "/eu/"
 */
const getRegionSitePath = (regionCode) => {
  if (!regionCode) return "/";
  const code = regionCode.trim().toLowerCase();
  if (code === "us") return "/";
  return "/" + code + "/";
};

/**
 * Builds and returns the geo data object required to populate the modal.
 * Also updates the module-level geoData reference for backward compatibility.
 * @param {string} geoPageUrl - geo specific page url
 * @param {string} countryName - country name to display on popup
 * @param {string} trackingCountryName - country name to populate the tracking
 * @param {string} regionCode - region code to display on popup
 * @param {string} countryCode - country code to display on popup CTA
 * @returns {Object} geo data object
 */
const doneCallback = (
  geoPageUrl,
  countryName,
  trackingCountryName,
  regionCode,
  countryCode
) => {
  const fmt_country_name = trackingCountryName
    ? trackingCountryName.replace(/\s+/, "").toLowerCase()
    : "";
  const data = {
    countryName,
    noThanksDataWa: "global-geoip-" + fmt_country_name + "-us",
    visitSiteDataWa: "global-geoip-" + fmt_country_name,
    modalShow: "goip-modal-show",
    geoPageUrl,
    regionCode,
    regionSitePath: getRegionSitePath(regionCode),
    countryCode
  };
  Object.assign(geoData, data);
  return data;
};

/**
 * Check the user visited page and help user to route coutry specifc page.
 * Returns a geo data object when the modal should be shown, false otherwise.
 */
const geoIpCheck = () => {
  const forceCountry = getURLParameter("country");
  const geoLocation = getCookie("AKES_GEO");

  // Normalize both codes to uppercase so cookie casing differences (e.g. "us" vs "US")
  // never cause a spurious mismatch or a missed match.
  const rawCountry = forceCountry || (geoLocation ? geoLocation.split("~")[0] : "") || "US";
  const countryCode = rawCountry.toUpperCase().trim();
  const regionCode = (getCookie("REGION") || "US").toUpperCase().trim();

  let countryName = "";
  let trackingCountryName = "";
  let geoPageUrl = "";
  let countryCodeStr = countryCode === "GB" ? "UK" : countryCode;

  //Invoke modal only when region code and country code are not same.
  if (countryCode && regionCode && countryCode !== regionCode) {
    let langPrefix = langPrefixArr[countryCode];
    countryName = countryNames[countryCode];
    trackingCountryName = countryNames[countryCode];

    // checking for path name, as we have two sites for Canada country
    if (countryCode === "CA" && location.pathname.indexOf("fr-ca") > -1) {
      langPrefix = langPrefixArr["FR-CA"];
    } else if (!countryNames[countryCode]) {
      if (euCountryNames[countryCode]) {
        countryName = "Europe";
        langPrefix = langPrefixArr["EU"];
        trackingCountryName = euCountryNames[countryCode];
        countryCodeStr = "EU";
      } else {
        countryName = "Global";
        langPrefix = langPrefixArr["GLOBAL"];
        // Fall back to the raw code so trackingCountryName is never undefined,
        // which would otherwise silently suppress the modal for any unlisted country.
        trackingCountryName = globalCountryNames[countryCode] || countryCode;
        countryCodeStr = "GLOBAL";
      }
    }

    // Use a case-insensitive attribute selector so hreflang="en-AU" (mixed case)
    // matches the lowercase langPrefix value we have, e.g. "en-au".
    const geoHrefLangEl = document.querySelector(`[hreflang="${langPrefix}" i]`);
    if (geoHrefLangEl) {
      geoPageUrl = geoHrefLangEl.getAttribute("href");
    } else {
      if (countryNames[countryCode]) {
        // check required as the country code and pathname are different for UK
        let sitePath =
          countryCode === "GB" ? "uk/" : countryCode.toLowerCase() + "/";

        // checking for path name, as we have two sites for Canada country
        if (countryCode === "CA" && location.pathname.indexOf("fr-ca") > -1) {
          sitePath = "fr-ca/";
        }

        geoPageUrl = "https://quickbooks.intuit.com/" + sitePath;
      } else {
        geoPageUrl = euCountryNames[countryCode]
          ? "https://quickbooks.intuit.com/eu/"
          : "https://quickbooks.intuit.com/global/";
      }
    }

    if (geoPageUrl && countryName && trackingCountryName && regionCode) {
      return doneCallback(
        geoPageUrl,
        countryName,
        trackingCountryName,
        regionCode,
        countryCodeStr
      );
    }
    return false;
  }
  return false;
};

const GEOIP_PREF_KEY = "geoip-site-preference";
const IVID_CACHE_KEY = "geoip-ivid-cache";

const getIvid = () => {
  const cookieIvid = getCookie("ivid");
  if (cookieIvid) {
    try {
      localStorage.setItem(IVID_CACHE_KEY, cookieIvid);
    } catch (e) {
      // Storage may be unavailable (private browsing, blocked storage, quota exceeded).
      // Cookie value is still returned — cache write failure is non-fatal.
      console.warn("GeoipModal: failed to cache ivid in localStorage.", e.name);
    }
    return cookieIvid;
  }
  try {
    return localStorage.getItem(IVID_CACHE_KEY) || null;
  } catch (e) {
    // Storage unavailable — cannot fall back to cached ivid.
    // Geo preference will not be restored until the cookie is readable.
    console.warn("GeoipModal: failed to read ivid cache from localStorage.", e.name);
    return null;
  }
};

/**
 * Waits for the ivid cookie to be set by getSameSiteAttributeScript.
 * Needed when loadInlineScriptsInBody.enabled=true — in that configuration,
 * getSameSiteAttributeScript is placed after <NextScript /> in the body,
 * so the React bundle executes and fires useEffect BEFORE the cookie is set.
 *
 * Strategy:
 *  1. Return immediately if ivid is already available (cookie or localStorage cache).
 *  2. Poll every `interval` ms up to `maxAttempts` times as an optimistic fast-path.
 *  3. Register a DOMContentLoaded backstop — because getSameSiteAttributeScript is a
 *     synchronous inline script, it is guaranteed to have run before DOMContentLoaded
 *     fires. This handles slow environments where the polling window expires first.
 *  4. A `called` guard ensures the callback is invoked exactly once regardless of
 *     which path wins.
 */
const waitForIvid = (callback, maxAttempts = 30, interval = 100) => {
  let called = false;

  const done = (ivid) => {
    if (called) return;
    called = true;
    callback(ivid);
  };

  const ivid = getIvid();
  if (ivid) {
    done(ivid);
    return;
  }

  if (typeof window !== "undefined") {
    if (document.readyState === "loading") {
      // Inline scripts haven't all run yet — DOMContentLoaded will fire after them.
      document.addEventListener("DOMContentLoaded", () => done(getIvid() || null), {
        once: true
      });
    } else {
      // readyState is 'interactive' or 'complete': inline scripts already ran.
      done(getIvid() || null);
      return;
    }
  }

  // Poll concurrently so we resolve as soon as ivid is available rather than
  // waiting for the full DOMContentLoaded event in the common case.
  const poll = (attemptsLeft) => {
    if (called) return;
    const current = getIvid();
    if (current) {
      done(current);
    } else if (attemptsLeft > 0) {
      setTimeout(() => poll(attemptsLeft - 1), interval);
    }
    // If poll exhausts without finding ivid, the DOMContentLoaded backstop fires.
  };

  poll(maxAttempts - 1);
};

/**
 * Returns true only for redirect targets that are safe to navigate to:
 *   - Relative paths on the same origin (start with "/" but not "//")
 *   - Absolute URLs that share the current window.location.origin
 * Rejects javascript:, data:, protocol-relative (//), and cross-origin URLs.
 */
const isSafeRedirectPath = (path) => {
  if (!path || typeof path !== "string") return false;
  if (path.startsWith("/") && !path.startsWith("//")) return true;
  try {
    const parsed = new URL(path);
    return parsed.origin !== "null" && parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};

const getSavedGeoPreference = (ivid) => {
  if (!ivid) return null;
  try {
    const stored = localStorage.getItem(GEOIP_PREF_KEY);
    if (!stored) return null;
    const prefs = JSON.parse(stored);
    return typeof prefs[ivid] === "string" ? prefs[ivid] : null;
  } catch (e) {
    // Storage unavailable or stored value is malformed JSON.
    // Geo preference cannot be restored — modal will proceed normally.
    console.warn("GeoipModal: failed to read geo preference from localStorage.", e.name);
    return null;
  }
};

const saveGeoPreference = (ivid, sitePath) => {
  if (!ivid || !sitePath) return;
  // Normalise absolute URLs (e.g. "https://quickbooks.intuit.com/global/") to
  // their pathname ("/global/") so the stored value is always a relative path
  // that works regardless of the current origin (localhost, staging, prod).
  let pathToStore = sitePath;
  try {
    const parsed = new URL(sitePath);
    // Preserve query and hash so a destination like "/global/?ref=geo#section"
    // round-trips correctly when used later as window.location.href.
    pathToStore = parsed.pathname + parsed.search + parsed.hash;
  } catch {
    // sitePath is already a relative path — use it as-is
  }
  if (!isSafeRedirectPath(pathToStore)) {
    console.warn("GeoipModal: rejected unsafe redirect path, preference not saved.");
    return;
  }
  try {
    const stored = localStorage.getItem(GEOIP_PREF_KEY);
    const prefs = stored ? JSON.parse(stored) : {};
    prefs[ivid] = pathToStore;
    localStorage.setItem(GEOIP_PREF_KEY, JSON.stringify(prefs));
  } catch (e) {
    // Storage unavailable or quota exceeded — preference will not persist.
    // Modal will reappear on next visit until storage becomes available.
    console.warn("GeoipModal: failed to save geo preference to localStorage.", e.name);
  }
};

export {
  geoIpCheck,
  getURLParameter,
  getCookie,
  geoData,
  getIvid,
  waitForIvid,
  isAlreadyOnPreferredSite,
  isSafeRedirectPath,
  getSavedGeoPreference,
  saveGeoPreference
};
